module.exports = __webpack_public_path__ + "static/media/9DESA18.37fd075e.jpg";